import { render } from "./App.vue?vue&type=template&id=237bc969"
const script = {}

import "./App.vue?vue&type=style&index=0&id=237bc969&lang=css"
script.render = render

export default script